<template>
  <div class="manager-files">
    <Header page="manager_file"/>
    <b-container>
      <div class="files">
        <b-navbar class="mypage__navbar">
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item href="#" class="mypage__navlink"><span class="mypage__statistic">合計</span><span class="mypage__statistic__number mypage__statistic__number__green">30</span></b-nav-item>
              <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">フォルダ</span><span class="mypage__statistic__number mypage__statistic__number__yellow">30</span></b-nav-item>
              <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">PDF</span><span class="mypage__statistic__number mypage__statistic__number__pink">30</span></b-nav-item>
              <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">画像</span><span class="mypage__statistic__number mypage__statistic__number__blue">30</span></b-nav-item>
              <b-nav-item href="#" class="mypage__navlink hidden-mb"><span class="mypage__statistic">動画</span><span class="mypage__statistic__number mypage__statistic__number__purple">30</span></b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto align-items-center">
              <button class="btn--filter mr-14"><img src="@img/icon-search.svg" /></button>
              <button class="btn--filter"><i class="icon-i-list"></i></button>
              <button class="btn--filter active"><i class="icon-i-grid"></i></button>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <!--<GridFiles />-->
        <ListFiles />
        <!--<div class="d-flex justify-content-center align-items-center no-result">
          <img src="@img/icon/no-result.svg" class="img-no-result" />
          <div class="no-result-text">検索結果がありませんでした。</div>
        </div>-->
      </div>
    </b-container>
    <AddFile />
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import AddFile from '@/components/Manager/FolderManagerment/AddFile'
import BtnGroupAdd from '@/components/Manager/FolderManagerment/BtnGroupAdd'
import ListFiles from '@/components/Manager/FolderManagerment/ListFiles'
import GridFiles from '@/components/Manager/FolderManagerment/GridFiles'
export default {
  name: 'Search_Result',
  data () {
    return {
      modalShow: false
    }
  },
  components: {Header, BtnGroupAdd, AddFile, ListFiles, GridFiles}
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
@import "@/assets/stylesheet/auth/listfile.scss";
</style>



// WEBPACK FOOTER //
// src/views/Manager/FolderManager/SearchResult.vue